import state from "../state/state";
import browserHistory from "../history";
import { showConfirm } from "./alertActions";
import { getFeatureFlagValue } from "../utils/featureFlags";

function isRootRelativeInternalPath(path) {
	return typeof path === "string" && path.charAt(0) === "/" && path.charAt(1) !== "/";
}

function hasCaseInsensitiveQueryParam(path, paramName) {
	const hashIndex = path.indexOf("#");
	const pathWithoutHash = hashIndex === -1 ? path : path.substring(0, hashIndex);
	const queryIndex = pathWithoutHash.indexOf("?");
	if (queryIndex === -1) {
		return false;
	}

	const normalizedParamName = paramName.toLowerCase();
	return pathWithoutHash.substring(queryIndex + 1).split("&").some(part => {
		const rawKey = part.split("=", 1)[0];
		try {
			return decodeURIComponent(rawKey.replace(/\+/g, " ")).toLowerCase() === normalizedParamName;
		} catch (err) {
			return rawKey.toLowerCase() === normalizedParamName;
		}
	});
}

function normalizeExplicitHealthStreamFutureValue(value) {
	if (value === undefined || value === null) {
		return "";
	}

	return `${value}`.trim();
}

export function preserveHealthStreamFutureQueryParam(path, urlParams = null) {
	if (!isRootRelativeInternalPath(path) || hasCaseInsensitiveQueryParam(path, "hsFuture")) {
		return path;
	}

	const explicitValue = normalizeExplicitHealthStreamFutureValue(
		getFeatureFlagValue("hsFuture", urlParams)
	);
	if (!explicitValue) {
		return path;
	}

	const hashIndex = path.indexOf("#");
	const pathWithoutHash = hashIndex === -1 ? path : path.substring(0, hashIndex);
	const hash = hashIndex === -1 ? "" : path.substring(hashIndex);
	const separator = pathWithoutHash.indexOf("?") === -1
		? "?"
		: (pathWithoutHash.endsWith("?") || pathWithoutHash.endsWith("&") ? "" : "&");

	return `${pathWithoutHash}${separator}hsFuture=${encodeURIComponent(explicitValue)}${hash}`;
}

export function navigateTo(target, confirmNavigate = false) {
	if (confirmNavigate) {
		showConfirm("Are you sure you want to leave this page? All unsaved changes will be lost.", "Leave Page?", () => {
			doNavigate(target);
		});
	} else {
		doNavigate(target);
	}
}

function doNavigate(target) {
	let previousTarget = state.get(["appState", "navPanel", "selected"]);

	let path;
	if (target === "home") {
		// path = "/home";
		path = "/home"; // For now
	} else if (target === "search") {
		path = "/search";
	} else if (target === "chat") {
		path = "/chat";
	} else if (target === "searchHistory") {
		path = "/searchHistory";
	} else if (target === "dashboard") {
		path = "/dashboard";
	} else if (target === "myChecklists") {
		path = "/checklists";
	} else if (target === "history") {
		path = "/history";
	} else if (target === "timers") {
		path = "/timers";
	} else if (target === "import") {
		path = "/import";
	} else if (target === "organization") {
		path = "/organization";
	} else if (target === "profile") {
		path = "/profile";
	} else if (target === "login") {
		path = "/login";
	} else if (target === "reporting") {
		path = "/reporting";
	} else if (target === "cms") {
		path = "/blockBank";
	} else if (target === "drive") {
		path = "/drive";
	} else if (target === "infinityInspire") {
		path = "/infinityInspire";
	} else if (target === "player") {
		path = "/player";
	} else if (target === "assignments") {
		path = "/assignments";
	} else if (target === "activityOperations") {
		path = "/activityOperations";
	} else if (target === "publications") {
		path = "/publications";
	} else if (target === "adminLogs") {
		path = "/adminLogs/webDiagnostics";
	} else if (target === "notificationTester") {
		path = "/admin/notifications";
	} else {
		path = target;
	}

	path = preserveHealthStreamFutureQueryParam(path, state.get(["appState", "urlParams"]));


	//do save if we were in the player	
	if (previousTarget === "player" && target !== "player") {
		state.set(["appState", "navPanel", "selected"], target);
		browserHistory.push(path);
	} else {
		state.set(["appState", "navPanel", "selected"], target);
		browserHistory.push(path);
	}
}
